import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/gossip';

export default function HomeHero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20abstract%20red%20carpet%20gala%20atmosphere%20with%20deep%20crimson%20velvet%20drapery%2C%20golden%20bokeh%20string%20lights%2C%20soft%20theatrical%20haze%20and%20elegant%20marble%20columns%2C%20cinematic%20warm%20amber%20tones%2C%20no%20people%2C%20high%20detail%20editorial%20background&width=1600&height=900&seq=gossip-hero-main-01&orientation=landscape"
          alt="深红帷幔与金色灯光营造的红毯典礼氛围"
          title="诱惑吃瓜 - 红毯名场面与高光同框"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
      </div>

      <div className="relative mx-auto flex w-full max-w-[1240px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="flex items-center gap-3 rounded-full border border-accent-400/50 bg-foreground-950/40 px-4 py-1.5 text-[11px] tracking-[0.2em] text-accent-300 md:text-xs">
          <i className="ri-sparkling-2-fill text-sm" aria-hidden="true"></i>
          颜值美照 · 生图红毯 · 高光同框
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-wide text-background-50 md:text-5xl lg:text-6xl">
          诱惑吃瓜 · 专注颜值与视觉盛宴
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
          美照生图、红毯造型、明星同框高光时刻全收录。想看谁的生图最能打，哪对同框最有火花，点开这里，高清美图与红毯名场面一次看个够。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/category/all"
            className="flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-gallery-view-2 text-lg" aria-hidden="true"></i>
            浏览全部图集
          </Link>
          <Link
            to="/about"
            className="flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-7 text-sm font-semibold text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
          >
            <i className="ri-information-line text-lg" aria-hidden="true"></i>
            了解诱惑吃瓜
          </Link>
        </div>

        <dl className="mt-14 grid w-full grid-cols-2 gap-y-8 border-t border-background-100/20 pt-8 md:grid-cols-4">
          {siteInfo.stats.map((item, index) => (
            <div key={item.label} className="flex flex-col items-center gap-1.5">
              <dt className="order-2 text-xs tracking-wider text-background-200/75">{item.label}</dt>
              <dd
                className={`order-1 font-heading text-2xl font-bold md:text-3xl ${
                  index === 1 ? 'text-accent-400' : 'text-background-50'
                }`}
              >
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}